var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSqlite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.193 1.588H2.737A2.745 2.745 0 000 4.325V29.09a2.745 2.745 0 002.737 2.737h14.79c-.168-7.36 2.345-21.642 7.666-30.239z",
    fill: "#0F80CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.377 2.386H2.737A1.94 1.94 0 00.798 4.325v22.958c4.901-1.88 12.258-3.504 17.344-3.43 1.022-5.345 4.026-15.818 6.235-21.467z",
    fill: "url(#paint0_linear_1908_1032)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.431.777c-1.538-1.371-3.4-.82-5.238.811-.273.242-.545.511-.816.798-3.143 3.336-6.062 9.514-6.968 14.232.353.716.629 1.63.81 2.329a21.097 21.097 0 01.245 1.048s-.028-.107-.144-.442l-.075-.217a2.504 2.504 0 00-.049-.12c-.205-.477-.772-1.483-1.022-1.921-.198.58-.385 1.165-.56 1.752.72 1.32 1.16 3.58 1.16 3.58s-.038-.147-.22-.659c-.16-.452-.961-1.855-1.151-2.183-.325 1.198-.453 2.007-.337 2.204.226.381.44 1.04.63 1.768.426 1.64.722 3.637.722 3.637l.026.336a33.333 33.333 0 00.083 4.097c.141 1.709.407 3.177.746 3.962l.23-.125c-.497-1.548-.7-3.577-.611-5.916.134-3.576.957-7.888 2.477-12.383 2.57-6.785 6.134-12.23 9.396-14.83-2.974 2.686-6.998 11.377-8.202 14.596-1.349 3.604-2.304 6.986-2.88 10.226.993-3.038 4.207-4.343 4.207-4.343s1.576-1.944 3.418-4.721c-1.104.252-2.916.682-3.522.937-.896.376-1.136.504-1.136.504s2.899-1.766 5.387-2.565C30.456 11.78 34.184 4.126 30.43.777z",
    fill: "#003B57"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1908_1032",
    x1: 12.587,
    y1: 2.896,
    x2: 12.587,
    y2: 25.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97D9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0F80CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F80CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqlite);
export default __webpack_public_path__ + "static/media/sqlite.73938fa8d65477a4d1ae36953c15ee5b.svg";
export { ForwardRef as ReactComponent };